<template>
  <div >
    <div>
      <div>
        <div class='col-sm-3' style="width:23%">
          <div class='col-sm-3 h-chart-datetimepickerText' style="width:35%"><span>{{$t('Alarm.statisticType')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker' style="width:65%;padding-right: 5px;">
            <ejs-dropdownlist v-model="queryConditions.statisticType" :fields='listFields' :dataSource='typeList' ></ejs-dropdownlist>
          </div>
        </div>
        <div class='col-sm-3' style="width:20%">
          <div class='col-sm-3 h-chart-datetimepickerText' style="width:35%"><span>{{$t('Alarm.notifystart')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker' style="width:65%;padding-right: 5px;">
            <ejs-datetimepicker :format='dateFormat' :step='60' :locale='locale' timeFormat='HH:mm:ss' :value='startDateValue' :change='changeStart'></ejs-datetimepicker>
          </div>
        </div>
        <div class='col-sm-3'  style="width:20%">
          <div class='col-sm-3 h-chart-datetimepickerText' style="width:35%"><span>{{$t('Alarm.notifyend')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker'  style="width:65%;padding-right: 5px;">
            <ejs-datetimepicker :format='dateFormat' :step='60' :locale='locale' timeFormat='HH:mm:ss' :value='endDateValue' :change='changeEnd'></ejs-datetimepicker>
          </div>
        </div>
        <div class='col-sm-3'>
          <div class='col-sm-9 h-chart-date-datetimepicker'>
            <ejs-button cssClass="e-btn e-control e-primary"  v-on:click.native="getStatisticData">{{$t('Alarm.confirm')}}</ejs-button>
          </div>
        </div>
      </div>
    </div>
    <div class='h100vh-200 width-100vw h-scroll' :style="styleColorVar">
      <ejs-grid ref='grid' id='alarmStatisticPageId' height='calc(100% - 0px)' :dataSource='data'  :contextMenuOpen='menuBeforeOpenFunc'
        :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :actionComplete='actionComplete'>
        <e-columns>
          <e-column type='checkbox' textAlign='Center' width='66'></e-column>
          <e-column v-if='!hidden.neName' :visible='true' field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
          <e-column v-if='!hidden.subName' :visible='true' field='subName' :headerText='$t("Alarm.subnetName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat'></e-column>
          <e-column field='count' :headerText='$t("Alarm.alarmCount")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='clearDuration' :headerText='$t("Alarm.unclearedDuration")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'statisticsTable',
  props: {
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      queryConditions: {
        startTime: '',
        endTime: '',
        statisticType:0
      },
      listFields: {
        text: 'name',
        value: 'code'
      },
      typeList: [
        { name: this.$t('Alarm.statisticType_0'), code: 0 },
        { name: this.$t('Alarm.statisticType_1'), code: 1 },
        { name: this.$t('Alarm.statisticType_2'), code: 2 }
      ],
      styleColorVar:{},
      selectionOptions: { type: 'Multiple' },
      topoList: [],
      page: {
        pageNo: 1,
        pageSize: 16,
        totalCount: 0,
        pageCount: 10
      },
      data: [],
      hidden:{}
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  computed: {
    startDateValue() {
      const dateRange = this.queryConditions.startTime ? `${this.getDate(this.queryConditions.startTime)}` : '';
      return dateRange;
    },
    endDateValue() {
      const dateRange = this.queryConditions.endTime ? `${this.getDate(this.queryConditions.endTime)}` : '';
      return dateRange;
    }
  },
  methods: {
    levelFormat(grids, data) {
      data.levelStr = this.$t(`Alarm.alarmLevel_${data.level}`);
      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
    },
    getDate(date) {
      return this.turnToFormateDate(new Date(date));
    },
    turnToFormateDate(dateValue) {
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let hour = dateValue.getHours();
      if (hour < 10) {
        hour = `0${hour}`;
      }
      let minutes = dateValue.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      let sec = dateValue.getSeconds();
      if (sec < 10) {
        sec = `0${sec}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day} ${hour}:${minutes}:${sec}`;
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if ((!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) || (this.getCheckedData(true).length > 1)) {
        menuArgs.cancel = true;
      }
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Common.tips.onlyOneSelect')}`});
        return false;
      }
      return selectedRecords;
    },
    actionComplete() {
      this.$refs.grid.selectRow(0, true);
      this.$refs.grid.selectRow(0, true);
    },
    getCheckedVals() {
      const messageNos = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        messageNos.push(checkedData[i].messageNo);
      }
      return messageNos;
    },
    changeStart(args) {
      this.queryConditions.startTime = new Date(args.value).getTime();
      this.getTopData();
    },
    changeEnd(args) {
      this.queryConditions.endTime = new Date(args.value).getTime();
      this.getTopData();
    },
    getStatisticData(firstFlag) {
      // 获取表格数据
      const This = this;
      let principal = sessionStorage.getItem('principal');
      let user = JSON.parse(principal);
      let userId = user.userId;
      EventBus.$emit('loading', { ison: true });
      This.$axios.post('/lte/ems/fm/alarmhistory/statisticAnalysis.html', {
        type: this.queryConditions.statisticType + "",
        start: this.queryConditions.startTime,
        end: this.queryConditions.endTime,
        neList: This.roleNe,
        userId:userId,

      }).then((response) => {
        if (response && response.status === 200) {
          this.hiddenColumn();
          EventBus.$emit('loading', { ison: false });
          const result = response.data;
          This.data = result;
        }
      });
    },
    hiddenColumn(){
      var type=this.queryConditions.statisticType;
      if(type == 0){
        this.hidden.subName = true;
        this.hidden.neName = true;
      }else if(type == 1){
        this.hidden.subName = false;
        this.hidden.neName = true;
      }else{
        this.hidden.subName = true;
        this.hidden.neName = false;
      }
    }
  },
  mounted(){
    this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
  }
};
</script>
